import React, { useEffect, useRef } from 'react'
import { useDispatch, useSelector } from "react-redux";
import { Navigate, useNavigate, useLocation } from "react-router-dom";
import { useForm } from "react-hook-form";
import * as appConstants from '../../../overrides/appconstants'
import * as appUtility from '../../../infrastructure/apputilityfunctions'
import * as actions from '../actions/micustomeractions'
import Select from 'react-select';
import {
    Stepper,
    Step,
    StepLabel,
    Button,
    Box,
    Typography,
    TextField,
} from '@mui/material';
import ArrowForwardIcon from '@mui/icons-material/ArrowForward';
import ArrowBackIcon from '@mui/icons-material/ArrowBack';
import CheckIcon from '@mui/icons-material/Check';
import * as constant from '../constants'
import { Search } from '@mui/icons-material';
import SearchQuote from './SearchQuote';
import CustomPager from '../../../components/custompager';
import ProspectFullDetails from './ProspectDetails';
import MemberFullDetails from './MemberDetails'
import CustomerInformation from './CustomerInformation'


export default function FullMemberDetails() {

    const dispatch = useDispatch();
    const state = useSelector(state => state.miCustomerSharedReducer);

    const { register, handleSubmit, setValue, formState: { errors } } = useForm();
    var masters = state.masters;
    let basicInfoNewEnq = state.basicInfoNewEnq;
    let modalState = state.modalState;
    let memberDetails = state.memberBasicInfo;
    let quoteMembersList = state?.quoteMembers?.quoteMembersList;
    let prospectInformation = state.prospectInformation;
    let activeStep = state?.activeStep;
    let quoteDocuments = state?.quoteDocuments;

    let isCustomerConfirmed = basicInfoNewEnq?.isCustomerConfirmed == true

    useEffect(() => {
        dispatch(actions.getMICustomerMasters())

    }, []);

    const navigate = useNavigate();
    const showFinalPopup = async () => {
        if (activeStep !== 4 && quoteDocuments?.isMemberDocumentsSaved == false) {
            let dialogeData = {
                message: `Attach Documents first`,
                showConfirmPopup: true,
                isConfirm: false,
                isInfo: true,
            }

            await dispatch(actions.toggleConfirmPopup(dialogeData));
            return false;
        }

        var userRes = await dispatch(actions.showFinalPopup())
        // if (userRes) {
        //     navigate('/customerportal')
        // }
    }
    const handleBack = async () => {
        navigate('/customerportal?quote=1&encryptedEnquiryRefId1=' + basicInfoNewEnq?.encryptedEnquiryRefId1 + "&encryptedEnquiryRefId2=" + basicInfoNewEnq?.encryptedEnquiryRefId2)

    }

    return (
        <>

            <div className="row g-2">
                <div className="mb-1 col-md-12">
                </div>
            </div>
            {/* <form onSubmit={handleSubmit(onSubmit, onErrors)}> */}
            <div className="mt-2" >
                <div className="container">
                    {/* <ProspectFullDetails />  */}
                    <CustomerInformation />
                    <br />
                    {/* && prospectInformation?.isSaved */}
                    {quoteMembersList?.length > 0 &&
                        < MemberFullDetails />
                    }
                    <Box sx={{ marginTop: 2, marginBottom: 2, display: 'flex', justifyContent: 'flex-end' }}>

                        {/* <Button
                            className='mx-2'
                            variant="outlined"
                            type='button'
                            color="secondary"
                            onClick={handleBack}
                            startIcon={<ArrowBackIcon />}

                        >
                            Back
                        </Button> */}
                        {!isCustomerConfirmed && <Button
                            variant="contained"
                            color="success"
                            type="submit"
                            onClick={() => showFinalPopup()}
                            disabled={isCustomerConfirmed}
                        >
                            {isCustomerConfirmed ? "Application Confirmed!" : "Confirm Application"}
                        </Button>}
                        {isCustomerConfirmed && <Button
                            variant="contained"
                            color="success"
                            type="button"
                            disabled={isCustomerConfirmed}
                        >
                            {isCustomerConfirmed ? "Application Confirmed!" : "Confirm Application"}
                        </Button>}
                    </Box>
                </div>
            </div>

            {/* </form> */}




        </>

    )


}